import StyledHR from "./style";

const HR = () => {
  return <StyledHR />;
};

export default HR;
